import React, { Fragment, useEffect, useState } from 'react';
import useTranslations from '@/hooks/translations';
import Analytics from '@/services/Analytics';
import { getRecommendationList } from '@/models/user';
import Header from '../Header';
import useBrowserHistory from '../../../hooks/browserHistory';
import styles from './styles';
import OnboardingMultipleOptionCheck from '../OnboardingMultipleOptionCheck';
import OnboardingBigContinueButton from '../../app/OnboardingBigContinueButton';

const RELIGION_OPTIONS = [
  {
    title: 'onboarding_religion_selection_list_item_christanity',
    itemKey: 'christian',
    active: false,
  },
  {
    title: 'onboarding_religion_selection_list_item_buddhist',
    itemKey: 'buddhism',
    active: false,
  },
  {
    title: 'onboarding_religion_selection_list_item_hindu',
    itemKey: 'hinduism',
    active: false,
  },
  {
    title: 'onboarding_religion_selection_list_item_general_spirituality',
    itemKey: 'unaffiliated',
    active: false,
  },
  {
    title: 'onboarding_religion_selection_list_item_none',
    itemKey: 'none',
    active: false,
  },
];

export default function ReligionSelection({
  onNext,
  onBack,
  profile,
  experiments,
}) {
  useBrowserHistory('religiousPreference', true, onBack, onNext);

  const [religionSelection, setReligionSelection] = useState([]);
  const { t } = useTranslations();
  const [canSubmit, setCanSubmit] = useState(false);

  useEffect(() => {
    const getReligion = async () => {
      const response = await getRecommendationList('religion', profile);
      if (response && response?.length > 0) {
        const fetchedList = [];
        response.forEach((item) => {
          const configItem = RELIGION_OPTIONS.find(
            (option) => option.itemKey === item.id
          );
          if (configItem) {
            fetchedList.push(configItem);
          }
        });
        setReligionSelection(fetchedList);
      } else setReligionSelection(RELIGION_OPTIONS);
    };

    getReligion();
  }, []);

  const onSelectItem = ({ itemKey }) => {
    const newReligionList = religionSelection.map((religionItem) => {
      let newReligionItem = religionItem;
      if (religionItem.itemKey === 'none') {
        newReligionItem = { ...religionItem, active: false };
      }
      if (religionItem.itemKey === itemKey) {
        newReligionItem = {
          ...religionItem,
          active: !religionItem.active,
          selectedTime: Date.now(),
        };
      }
      if (itemKey === 'none') {
        newReligionItem = { ...religionItem, active: false };
        if (religionItem.itemKey === 'none') {
          newReligionItem = { ...religionItem, active: !religionItem.active };
        }
      }

      return newReligionItem;
    });
    setReligionSelection(newReligionList);
  };

  function onSubmit() {
    const religionSelectionObj = {};
    const selectedReligions = religionSelection
      .filter((religionItem) => {
        return religionItem.active === true;
      })
      .sort((a, b) => {
        return a.selectedTime - b.selectedTime;
      });

    selectedReligions.forEach((religion, index) => {
      religionSelectionObj[religion.itemKey] = index + 1;
    });

    const activeReligionList = Object.keys(religionSelectionObj);
    const activeReligionCount = activeReligionList.length;
    const activeReligionOrder = activeReligionList.map((x) => {
      return { type: x, order: religionSelectionObj[x] };
    });

    Analytics.track(`Religious Preference`, {
      Time: new Date().toTimeString().slice(0, 2),
      Day: new Date().getDay(),
      'Religious Preference Order': activeReligionOrder,
      'Religious Preference List': activeReligionList,
      'Religious Preference Count': activeReligionCount,
    });
    Analytics.setPeopleProperties({
      'Religion Preference List': activeReligionList,
      'Religion Preference Count': activeReligionCount,
    });
    onNext({
      religiousPreferences: religionSelectionObj,
    });
  }
  useEffect(() => {
    const activePreference = religionSelection.filter((res) => {
      return res.active;
    });

    setCanSubmit(activePreference.length >= 1);
  }, [religionSelection]);

  return (
    <Fragment>
      <Header
        title={t('onboarding_religion_selection_header')}
        subtitle={t('onboarding_religion_selection_subheader')}
        experiments={experiments}
      />
      <div className="item-container">
        <div className="background" />
        {religionSelection.map((item) => (
          <OnboardingMultipleOptionCheck
            dataTestId="onboardingReligionOptions"
            key={item.id}
            experiments={experiments}
            item={item}
            onClick={onSelectItem}
            title={t(item.title)}
            isActive={item.active}
          />
        ))}
        <OnboardingBigContinueButton
          title={t('button_continue')}
          experiments={experiments}
          onClick={() => {
            onSubmit();
          }}
          disabled={!canSubmit}
        />
      </div>
      <style jsx>{styles}</style>
    </Fragment>
  );
}
